export default {
    wrapperStyle: {
        width: '320px',
        margin: '0 auto',
        position: 'relative',
        paddingTop: 48,
        textAlign: 'center'
    }
};
